module.exports = __webpack_public_path__ + "img/btn_right.79ae38ec.jpg";